import React from 'react';
import { isNumber } from '@finect/front-utils/isNumber';
import { currencyFormat } from '@finect/front-utils/currencyFormat';
import { Label, Sparkline, EmptyValue } from './partials';
import { Triangle } from './Triangle';
export var Percent = function Percent(props) {
  var value = props.value,
    _props$value = props.value2,
    value2 = _props$value === void 0 ? null : _props$value,
    _props$decimals = props.decimals,
    decimals = _props$decimals === void 0 ? 2 : _props$decimals,
    _props$withSparkline = props.withSparkline,
    withSparkline = _props$withSparkline === void 0 ? false : _props$withSparkline,
    _props$withPositiveSi = props.withPositiveSign,
    withPositiveSign = _props$withPositiveSi === void 0 ? false : _props$withPositiveSi,
    _props$withPositive = props.withPositive,
    withPositive = _props$withPositive === void 0 ? false : _props$withPositive,
    _props$withNegative = props.withNegative,
    withNegative = _props$withNegative === void 0 ? false : _props$withNegative,
    _props$positive = props.positive,
    positive = _props$positive === void 0 ? false : _props$positive,
    _props$negative = props.negative,
    negative = _props$negative === void 0 ? false : _props$negative,
    _props$bold = props.bold,
    bold = _props$bold === void 0 ? false : _props$bold,
    _props$isRange = props.isRange,
    isRange = _props$isRange === void 0 ? false : _props$isRange,
    _props$inverse = props.inverse,
    inverse = _props$inverse === void 0 ? false : _props$inverse;
  if (!isNumber(value)) {
    return React.createElement(Label, {
      withPositive: withPositive,
      withNegative: withNegative,
      bold: bold,
      value: value,
      inverse: inverse
    }, React.createElement(EmptyValue, props, "\u2014"));
  }
  if (isRange) {
    return React.createElement(Label, {
      withPositive: withPositive,
      withNegative: withNegative,
      bold: bold,
      value: value,
      inverse: inverse
    }, React.createElement("span", null, withPositiveSign && value > 0 ? '+' : '', currencyFormat(value, decimals || 2)), "%", React.createElement("span", null, " - "), React.createElement("span", null, withPositiveSign && value2 > 0 ? '+' : '', currencyFormat(value2, decimals || 2)), "%");
  }
  var type = positive ? 'up' : negative ? 'down' : value > 0 ? 'up' : 'down';
  return React.createElement(Label, {
    withPositive: withPositive,
    withNegative: withNegative,
    positive: positive,
    negative: negative,
    bold: bold,
    value: value,
    inverse: inverse
  }, withSparkline && value !== 0 ? React.createElement(Sparkline, null, React.createElement(Triangle, {
    inverseColor: inverse,
    type: type
  })) : null, React.createElement("span", null, withPositiveSign && value > 0 ? '+' : '', currencyFormat(value, decimals || 2)), "%");
};